// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment.ts which uses `environment.ts.ts`, but if you do
// `ng build --env=prod` then `environment.ts.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  dashboardApiUrl : 'https://mcre-dashboard-api-test.nonprod-prognplay-ihm.com/api/v1',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts